import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BusinessProductPaymentModifierListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-product-payment-modifier-list',
  templateUrl: 'business-product-payment-modifier-list.html',
})
export class BusinessProductPaymentModifierListPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessProductPaymentModifierListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-product-payment-modifier-list/business-product-payment-modifier-list.ts